import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { ActiveSpeakerIcon } from '@gem/call/components/ActiveSpeakerIcon/ActiveSpeakerIcon';
import { IcMicOff16Icon, IcShareScreen16Icon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import Entities from 'STORE';

import AudioState from '../AudioState';
import styles from './styles.m.css';

const StreamerMeta = ({ className, streamer, isMinimize }) => {
  const activeStreamer = Entities.ActiveStream.stream.activeStreamer;

  return (
    <>
      <div className={classNames(styles.container, { [styles.minimize]: isMinimize }, className)}>
        {streamer.isSharedScreen && isMinimize && (
          <IconView
            Icon={IcShareScreen16Icon}
            className={styles.sharingIcon}
            size="small"
          />
        )}
        {!activeStreamer.isSharedScreen &&
          activeStreamer.streamer.isSharedScreen &&
          !isMinimize && (
            <IconView
              Icon={IcShareScreen16Icon}
              className={styles.sharingIcon}
              size="small"
            />
          )}
        {!isMinimize && (
          <div className={styles.metaGroup}>
            <div className={styles.name}>{streamer.username}</div>
            {streamer.isAudioMuted ? (
              <IconView
                Icon={IcMicOff16Icon}
                size="small"
                className={styles.muted}
              />
            ) : (
              <ActiveSpeakerIcon
                isBig
                isSilence={!streamer.isActiveSpeaker}
              />
            )}
          </div>
        )}
      </div>
      {isMinimize && !streamer.isSharedScreen && (
        <AudioState
          streamer={streamer}
          className={styles.audioState}
        />
      )}
    </>
  );
};

export default observer(StreamerMeta);
